import React, { useRef } from "react";
import { isSet } from "../../../Utils/CommonFunctions";
import SwitchItems from "../../FormBuilder/Builder/FormInputs/SwitchItems";
import FormInputFields from "../../FormInputFields";
import { ErrorBlock } from "../../../hoc/FormInput";
import { extractFieldValue, extractOptions, getOutputFieldsElement, injectVariableValues, isValidJson } from "../MarkupFunctions";
import PagesInputFields from "../../PagesInputFields";
import ScmSubFormItem from "./ScmSubFormItem";

// GET FIELDS PROPS ELEMENT
const ScmInputTextField = ({ attributes, elmtParams }) => {
  const { defProps,children,dynamicVar } = elmtParams;
  const dataElmt = getOutputFieldsElement(attributes, elmtParams);
  let dataElmtStr;
  if (React.isValidElement(dataElmt)) {
    // It's already a React element, keep as is
    dataElmtStr = '';
  } else if (isValidJson(dataElmt)) {
    // It's JSON text
    dataElmtStr = JSON.stringify(dataElmt);
  } else {
    // It's plain string or other
    dataElmtStr = dataElmt;
  }
  const hasLoadedPage = useRef(false); 
  const attribsName = attributes.hasOwnProperty('name') ? attributes.name : '';
  const { modType, fieldGroups, formFields,isPreview,resourcesList,onChangeResourcesFieldHandler,fieldFormPayload } = defProps;
  let element = null;
  let updatedAttributes = {...attributes};
  // console.log('isPreview',updatedAttributes);
  if(isPreview===true){
    element = <FormInputFields 
                {...attributes} 
                type='TextInput' 
                changeHandler={()=>{}} 
                value=""  />
  }
 
  const obj  = extractFieldValue(dynamicVar,attribsName);
  // Check if this is a subform field and route to ScmSubFormItem
  if(isSet(obj,null)!==null && isSet(obj.is_subform_field,false)===true){
    // Extract subform context from dynamicVar.subformvar
    const subformvar = dynamicVar?.subformvar;
    
    if (subformvar && subformvar.rowData && subformvar.rowIndex !== undefined && subformvar.section) {
      const {
        rowData,
        rowIndex,
        subformIndex,
        section,
        pageType,
        isOpenBox,
        reminderDisplayText,
        onChangeInputAction,
        processFieldData
      } = subformvar;
      
      // Find the field in section.data that matches obj
      const fieldInSection = obj;
      if (fieldInSection) {
        // Use processFieldData from subformvar if available, otherwise process manually
        let processedData;
        if (processFieldData && typeof processFieldData === 'function') {
          processedData = processFieldData(fieldInSection);
        } else {
          // Manual processing if processFieldData not available
          const columnIndex = rowData.subform_column_values?.findIndex(
            (column) => column.table_descriptor_id == fieldInSection.id
          ) ?? -1;
          
          let columnData = {};
          if (columnIndex !== -1) {
            columnData = rowData.subform_column_values[columnIndex];
          }
          
          processedData = {
            reminder: isSet(columnData.reminder, ""),
            files: isSet(columnData.files, ""),
            selectedValue: isSet(columnData.selected_value, ""),
            selected_value_text: isSet(columnData.selected_value_text, ""),
            selecteddpnm: isSet(columnData.dpnm, ""),
            overridden: isSet(columnData.overridden, false),
            currency_code: isSet(columnData.currency_code, "CAD"),
            options: isSet(columnData.options, fieldInSection.options),
            columnIndex: columnIndex
          };
        }
        
        // Get validation data
        const subformValidation = subformvar.subformValidation || 
                                     elmtParams.defProps?.validationForms?.[modType] || 
                                     {};
        
        // Render ScmSubFormItem with all required props
        // console.log('processedData',fieldInSection);
        element = (
          <ScmSubFormItem
            item={fieldInSection}
            modType={modType}
            keyIndex={fieldInSection.id || attribsName}
            subFormIndex={subformIndex}
            columnIndex={processedData.columnIndex}
            rowIndex={rowIndex}
            pageType={pageType}
            subformValidation={subformValidation}
            reminderDisplayText={reminderDisplayText}
            rowId={rowData.id || ''}
            isOpenBox={isOpenBox}
            section={section}
            reminder={processedData.reminder}
            files={processedData.files}
            selectedValue={processedData.selectedValue}
            selected_value_text={processedData.selected_value_text}
            selecteddpnm={processedData.selecteddpnm}
            overridden={processedData.overridden}
            currency_code={processedData.currency_code}
            options={processedData.options}
            onChangeInputAction={fieldInSection?.onChangeInputAction || onChangeInputAction}
            elmtParams={elmtParams}
            defProps={defProps}
          />
        );
        
        // Return early to prevent other field matching logic
        return element;
      }
    }
  }

  fieldGroups.forEach((section) => {
    if (section.type !== 'subform') {
      section.data.forEach((field, itemIndex) => {
        if (field.label?.blocks?.[0]?.text?.toLowerCase() === attribsName.toLowerCase()) {
          const fieldObj = {
            section_index: section.section_index,
            itemIndex: field.itemIndex,
            modType,
            item: {
              ...field,
              modType,
            },
          };

          let appendAttr = {};
          if (isSet(attributes.class, '') !== '') {
            appendAttr.className = isSet(attributes.class, '');
          }

          element = (
            <SwitchItems
              {...defProps}
              key={itemIndex}
              fieldObj={fieldObj}
              item={{
                ...field,
                displayType: isSet(attributes.displaytype, ''),
                customAttr: isSet(attributes, ''),
                modType,
              }}
              inputBlockOnly={true}
              onlyInputComponent={true}
              errorBlock={true}
              isLabel={isSet(attributes.withlabel, true) === 'false' ? false : Boolean(isSet(attributes.withlabel, true))}
              withoutBlock={isSet(attributes.inputOnly, true) === 'false' ? false : Boolean(isSet(attributes.inputOnly, true))}
              section={section}
              {...appendAttr}
            />
          );
        }
      });
    }
  });

  const indexing = formFields.findIndex((i) => attribsName.toLowerCase() === i.label.toLowerCase());
  if (indexing !== -1) {
    if (updatedAttributes.name) {
      delete updatedAttributes.name;
    }
    element = (
      <>
        <FormInputFields  {...formFields[indexing]} {...updatedAttributes} />
        <ErrorBlock message={isSet(formFields[indexing].error, '')} />
      </>
    );
  }
  const resourcesIndexing =-1;// resourcesList.findIndex((i) => attribsName.toLowerCase() === i.variable_name.toLowerCase());
  // console.log('resourcesIndexing',resourcesIndexing);
  if(resourcesIndexing!==-1){
        if (!hasLoadedPage.current) {
          hasLoadedPage.current = true;
          let defaultValue = isSet(attributes?.defaultvalue,'');
          if (defaultValue.indexOf('${') !== -1 && defaultValue.indexOf('}') !== -1){
              const updateDefaultValue = injectVariableValues(defaultValue,attributes,elmtParams,defaultValue);
              onChangeResourcesFieldHandler(resourcesList[resourcesIndexing],updateDefaultValue);
              
          }
      }
      let options = [];
      const resource = resourcesList[resourcesIndexing];
      try{
        const opt = eval(updatedAttributes.options);
        if(Array.isArray(opt)===true){
          isSet(opt,[]).forEach((i)=>{
            options.push({
              id:i,
              value:i
            });
          })
          if(options.length>0){
            updatedAttributes ={
              ...updatedAttributes,
              options:options
            }
          }
        }
        
      }catch(e){

      }
      // console.log('fieldFormPayload',resource,eval(updatedAttributes.options));
      element = (
      <>
        <FormInputFields 
          {...updatedAttributes} 
          type={isSet(updatedAttributes.type,resourcesList[resourcesIndexing]?.type)}
          value={fieldFormPayload[resource.api_name]?.selected_value}
          changeHandler={(value)=>onChangeResourcesFieldHandler(resourcesList[resourcesIndexing],value)}
          // {...resourcesList[resourcesIndexing]}
           />
        {/* <ErrorBlock message={isSet(resourcesList[resourcesIndexing].error, '')} /> */}
      </>
    );
  }else if(element===null && isSet(attributes.type,null)!==null){
    if(attributes.type==='PickList' || attributes.type==='Picklist' || attributes.type==='MultiSelect'){
        const options = extractOptions(children,attributes.type);
         if(options.length>0){
            updatedAttributes ={
              ...updatedAttributes,
              // isDefault:true,
              options:options
            }
          } 
          // console.log('attributes',attributes,options);
    }
   
     element = (
      <>
        <PagesInputFields 
          {...updatedAttributes} 
          childrenProps={children}
          value={fieldFormPayload[updatedAttributes.name]?.selected_value || dataElmtStr}
          changeHandler={(value)=>onChangeResourcesFieldHandler({api_name:updatedAttributes?.name},value)}
          // {...resourcesList[resourcesIndexing]}
           />
        {/* <ErrorBlock message={isSet(resourcesList[resourcesIndexing].error, '')} /> */}
      </>
    );
  } 
  return element;
};


ScmInputTextField.defaultProps = {
    attributes:{},
    elmtParams:{}
}

export default ScmInputTextField;
